import { TextField } from '@mui/material'
import { normalizeManualSalesOrder } from '../utils/manualSalesOrder'

const ManualSoNumberFields = ({
  soNumber,
  reason,
  onSoNumberChange,
  onReasonChange,
  disabled = false,
}) => {
  const validation = normalizeManualSalesOrder(soNumber, reason)

  return (
    <>
      <TextField
        label="SO Number"
        value={soNumber}
        onChange={(e) => onSoNumberChange(e.target.value)}
        disabled={disabled}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        inputProps={{ 'aria-label': 'SO Number', maxLength: 32 }}
        helperText="Optional. Leave blank to create the SAP sales order automatically."
      />
      {validation.active ? (
        <TextField
          label="Reason"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          disabled={disabled}
          required
          fullWidth
          multiline
          minRows={2}
          size="small"
          sx={{ mb: 2 }}
          error={Boolean(validation.error)}
          inputProps={{ 'aria-label': 'SO Number reason', maxLength: 500 }}
          helperText={
            validation.error ||
            'Required when an SO Number is entered. Explains why SAP order creation was skipped.'
          }
        />
      ) : null}
    </>
  )
}

export default ManualSoNumberFields
